export const BLUR_MAX_FPS = 15;
export const BLUR_FRAME_BUDGET_MS = 1000 / BLUR_MAX_FPS;

const PROFILES = [
  { width: 640, height: 360 },
  { width: 1280, height: 720 },
] as const;

/** Measure the actual frame pipeline, rather than guessing from CPU count.
 * Require sustained evidence and a cooldown to avoid resolution flicker. */
export class AdaptiveBlurQuality {
  private tier = 1;
  private slowFrames = 0;
  private fastFrames = 0;
  private cooldown = 0;

  getSize(sourceWidth: number, sourceHeight: number) {
    const profile = PROFILES[this.tier];
    const width = sourceWidth > 0 ? sourceWidth : profile.width;
    const height = sourceHeight > 0 ? sourceHeight : profile.height;
    const scale = Math.min(1, profile.width / width, profile.height / height);
    return {
      width: Math.max(2, Math.floor((width * scale) / 2) * 2),
      height: Math.max(2, Math.floor((height * scale) / 2) * 2),
    };
  }

  recordFrame(durationMs: number): 'load' | 'headroom' | null {
    if (this.cooldown > 0) {
      this.cooldown -= 1;
      return null;
    }
    this.slowFrames =
      durationMs > BLUR_FRAME_BUDGET_MS ? this.slowFrames + 1 : 0;
    // A 720p frame has four times as many pixels; allow plenty of headroom
    // before retrying the higher resolution after a reduction.
    this.fastFrames = durationMs < 12 ? this.fastFrames + 1 : 0;
    if (this.tier === 1 && this.slowFrames >= 8) {
      this.tier = 0;
      this.cooldown = 75;
      this.fastFrames = 0;
      this.slowFrames = 0;
      return 'load';
    }
    if (this.tier === 0 && this.fastFrames >= 45) {
      this.tier = 1;
      this.cooldown = 0;
      this.fastFrames = 0;
      this.slowFrames = 0;
      return 'headroom';
    }
    return null;
  }
}
